module.exports = __webpack_public_path__ + "assets/roboto-v20-latin-regular.ttf?329ae1c377b1fb667f5be6abd50327fc";